var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPedit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:edit-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.82867 11.9971H2V9.16911L9.62333 1.54578C9.74835 1.4208 9.91789 1.35059 10.0947 1.35059C10.2714 1.35059 10.441 1.4208 10.566 1.54578L12.452 3.43111C12.577 3.55613 12.6472 3.72567 12.6472 3.90244C12.6472 4.07922 12.577 4.24876 12.452 4.37378L4.82867 11.9971ZM2 13.3304H14V14.6638H2V13.3304Z",
    fill: "#959595"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPedit);
export default __webpack_public_path__ + "static/media/pedit.d22a6a6c3b214b9166b496133fa034de.svg";
export { ForwardRef as ReactComponent };